  import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, signal } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BuyertinService } from '../../../services/buyertin/buyertin.service';
import {
  eitherBuyerTinOrIdentificationNumberValidator,
  variableLengthValidator,
} from '../../../shared/Validators/custom-validators';
import { DialogComponent } from '../../../shared/components/dialog/dialog.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
interface IdentificationTypeOption {
  label: string;
  value: string;
}
@Component({
  selector: 'app-buyer-tin',
  templateUrl: './buyer-tin.component.html',
  styleUrls: ['./buyer-tin.component.scss'],
  standalone: false
})
export class BuyerTinComponent implements OnInit {
  private readonly isFormSubmittedState = signal(false);
  private readonly identificationNumberErrorMessageState = signal('');
  private readonly identificationNumberinvalidErrorMessageState = signal('');
  private readonly resetFlagState = signal(false);

  get isFormSubmitted() { return this.isFormSubmittedState(); }
  set isFormSubmitted(value: boolean) { this.isFormSubmittedState.set(value); }
  get identificationNumberErrorMessage() { return this.identificationNumberErrorMessageState(); }
  set identificationNumberErrorMessage(value: string) { this.identificationNumberErrorMessageState.set(value); }
  get identificationNumberinvalidErrorMessage() { return this.identificationNumberinvalidErrorMessageState(); }
  set identificationNumberinvalidErrorMessage(value: string) { this.identificationNumberinvalidErrorMessageState.set(value); }
  get resetFlag() { return this.resetFlagState(); }
  set resetFlag(value: boolean) { this.resetFlagState.set(value); }

  @Output() formSubmitted = new EventEmitter<void>();
  @Input() sellerBRN: any = null;
  buyerTinForm!: FormGroup;
  
  requiredErrorMessage: string = '';
  customerTypes = [
    { label: 'Malaysian Non Individual', value: 'nonIndividual' },
    { label: 'Malaysia Individual', value: 'malaysiaIndividual' },
    { label: 'Foreign Individual', value: 'foreignIndividual' },
    { label: 'Foreign Non Individual', value: 'foreignNonIndividual' }
  ];
  dialogRef: DynamicDialogRef | null = null;

  identificationTypes = [
    { label: 'ARMY', value: 'army' },
    { label: 'BRN', value: 'brn' },
    { label: 'NRIC', value: 'nric' },
    { label: 'PASSPORT', value: 'passport' },
  ];
  filteredIdentificationTypes: IdentificationTypeOption[] = [];
  hasErrors: boolean = false;
  constructor(
    private fb: FormBuilder,
    private buyerTinService: BuyertinService,
    private cdRef: ChangeDetectorRef,
    private dialogService: DialogService
  ) { }
  ngOnInit() {
    this.createForm();
  }
  createForm() {
    this.buyerTinForm = this.fb.group(
      {
        customerType: ['', Validators.required],
        buyerTinAvailable: ['', Validators.required],
        buyerTin: ['', [Validators.required, variableLengthValidator(14)]],
        identificationNumberAvailable: ['', Validators.required],
        identificationType: ['', Validators.required],
        identificationNumber: ['', Validators.required],
      },
      { validators: eitherBuyerTinOrIdentificationNumberValidator() } // Apply custom validator here
    );
  }

  get f() {
    return this.buyerTinForm.controls;
  }
  getFormData() {
    return this.buyerTinForm.value;
  }
  onIdentificationTypeChange(event: any) {
    const selectedIdentificationType = event.value;
    this.updateIdentificationNumberValidator(selectedIdentificationType);
  }
  updateIdentificationNumberValidator(identificationType: string) {
    let maxLength = 12;
    let errorMessage = 'Identification Number is required';

    switch (identificationType) {
      case 'brn':
        maxLength = 20;
        break;
      case 'army':
      case 'passport':
      case 'nric':
        maxLength = 12;
        break;
    }

    const identificationNumberControl = this.buyerTinForm.get(
      'identificationNumber'
    );

    if (identificationNumberControl) {
      identificationNumberControl.clearValidators();
      identificationNumberControl.setValidators([
        Validators.required,
        variableLengthValidator(maxLength),
      ]);

      identificationNumberControl.updateValueAndValidity(); // Ensure validators are applied
    }

    this.identificationNumberErrorMessage = `Please provide a valid Identification Number (max ${maxLength} characters)`;
  }

  updateIdentificationTypeOptions(customerType: string) {
    this.resetvalues(customerType);

    console.log(this.buyerTinForm.value);

    const allIdentificationTypes = [
      { label: 'ARMY', value: 'army', disabled: false },
      { label: 'BRN', value: 'brn', disabled: false },
      { label: 'NRIC', value: 'nric', disabled: false },
      { label: 'PASSPORT', value: 'passport', disabled: false },
    ];

    let enabledIdentificationTypes: any = [];

    // Logic to filter the options based on customerType
    if (customerType === 'foreignIndividual') {
      enabledIdentificationTypes = [
        { label: 'NRIC', value: 'nric', disabled: false },
        { label: 'PASSPORT', value: 'passport', disabled: false },
      ];
    } else if (customerType === 'malaysiaIndividual') {
      enabledIdentificationTypes = [
        { label: 'ARMY', value: 'army', disabled: false },
        { label: 'NRIC', value: 'nric', disabled: false },
      ];
    } else if (customerType === 'nonIndividual') {
      enabledIdentificationTypes = [
        { label: 'BRN', value: 'brn', disabled: false },
      ];
    } else if (customerType === 'foreignNonIndividual') {
      enabledIdentificationTypes = [
        { label: 'BRN', value: 'brn', disabled: false },
      ];
    }

    // Disable options that are not enabled based on the customerType
    const filteredIdentificationTypes = allIdentificationTypes.map(
      (option) => ({
        ...option,
        disabled: !enabledIdentificationTypes.some(
          (enabledOption: any) => enabledOption.value === option.value
        ),
      })
    );

    this.filteredIdentificationTypes = filteredIdentificationTypes;

    const currentIdentificationType =
      this.buyerTinForm.get('identificationType')?.value;

    const isCurrentValueValid = enabledIdentificationTypes.some(
      (option: any) => option.value === currentIdentificationType
    );

    if (!isCurrentValueValid) {
      this.buyerTinForm.get('identificationType')?.setValue('');
    }
    this.buyerTinForm.get('identificationType')?.updateValueAndValidity();
  }

  resetvalues(customerType: string) {
    this.resetFlag = false;
    if (customerType != '') {
      this.buyerTinForm.patchValue({
        buyerTinAvailable: '',
        buyerTin: '',
        identificationNumberAvailable: '',
        identificationNumber: '',
        identificationType: '',
      });

      Object.keys(this.buyerTinForm.controls).forEach((controlName) => {
        const control = this.buyerTinForm.get(controlName);
        control?.markAsPristine();
        control?.markAsUntouched();
      });
      this.cdRef.detectChanges();
      this.resetFlag = true;
    }
  }
  updateFormFields(customerType: string) {
    this.updateIdentificationTypeOptions(customerType);
    switch (customerType) {
      case 'foreignIndividual':
        this.setForeignIndividualFields(customerType);
        break;
      case 'malaysiaIndividual':
        this.setMalaysiaIndividualFields(customerType);
        break;
      case 'nonIndividual':
        this.setNonIndividualFields(customerType);
        break;
      case 'foreignNonIndividual':
        this.setForeignNonIndividualFields(customerType);
        break;
      default:
        break;
    }
  }

  checkerror(): void {
    const buyerTinAvailable = this.buyerTinForm.get('buyerTinAvailable')?.value;
    const identificationNumberAvailable = this.buyerTinForm.get(
      'identificationNumberAvailable'
    )?.value;
    const buyerTin = this.buyerTinForm.get('buyerTin')?.value;
    const identificationNumber = this.buyerTinForm.get(
      'identificationNumber'
    )?.value;
    const customerType = this.buyerTinForm.get('customerType')?.value;
    if (customerType != 'nonIndividual') {
      if (
        customerType !== 'foreignNonIndividual' &&
        buyerTinAvailable === 'no' &&
        identificationNumberAvailable === 'no'

      ){
        this.identificationNumberinvalidErrorMessage =
          'Provide either Buyer TIN or Identification number.';
      } else {
        this.identificationNumberinvalidErrorMessage = '';
      }
    } else {
      this.identificationNumberinvalidErrorMessage = '';
    }
  }


  openBuyerTinPromptBox() {
    this.dialogRef = this.dialogService.open(DialogComponent, {
      header: 'Confirmation',
      width: '600px',
      data: {
        title: '',
        messages: [
          'Is the Buyer falling under any of the special categories as below?',
          '<ul>' +
          '<li>Government</li>' +
          '<li>State government and state authority</li>' +
          '<li>Government authority</li>' +
          '<li>Local authority</li>' +
          '<li>Statutory authority and statutory body</li>' +
          '<li>Exempt institutions that are not assigned with TIN</li>' +
          '</ul>',
        ],
        confirm: true,
        onNo: () => {
          console.log('User clicked No');
          this.dialogRef?.close();  // Close the first dialog before opening the second one
          setTimeout(() => {
            this.showBuyerTinError();  // Trigger the second dialog after closing the first
          }, 200);
        },
        onYes: () => console.log('User clicked Yes'), // Custom action for "No"
      },
      contentStyle: { 'max-height': '700px', overflow: 'auto' },
    });
  }

  showBuyerTinError() {
    console.log("Inside showBuyerTinError");
    const errMsg = "Error: If the buyer does not fall under one of these special categories, selecting “No” for Buyer TIN Available is not allowed. Please select “Yes” for Buyer TIN Available and thereafter provide the actual Tax Identification Number (TIN).";
    this.openBuyerTinErrorDialogue(errMsg);
  }

  setCommonIndividualFields(
    buyerTinDefault: string,
    identificationNumberDefault: string,
    customerType: string
  ) {
    const buyerTinAvailableControl = this.buyerTinForm.get('buyerTinAvailable');
    const buyerTinControl = this.buyerTinForm.get('buyerTin');
    const identificationNumberAvailableControl = this.buyerTinForm.get(
      'identificationNumberAvailable'
    );
    const identificationNumberControl = this.buyerTinForm.get(
      'identificationNumber'
    );

    // Set Validators
    buyerTinAvailableControl?.setValidators([Validators.required]);
    buyerTinControl?.setValidators([
      Validators.required,
      variableLengthValidator(14),
    ]);
    identificationNumberAvailableControl?.setValidators([Validators.required]);
    identificationNumberControl?.setValidators([Validators.required]);
    this.buyerTinForm.setValidators(
      eitherBuyerTinOrIdentificationNumberValidator()
    );

    buyerTinAvailableControl?.valueChanges.subscribe((value) => {

      if(this.resetFlag){

      const custType = this.buyerTinForm.get('customerType');
      if (custType?.value === 'nonIndividual' && value === 'no') {

        this.openBuyerTinPromptBox();
        buyerTinControl?.setValue(buyerTinDefault);
        buyerTinControl?.disable();

      } else if (custType?.value !== 'nonIndividual' && value === 'no') {

        buyerTinControl?.setValue(buyerTinDefault);
        buyerTinControl?.disable();

        if (custType?.value === 'foreignNonIndividual') {
          identificationNumberAvailableControl?.setValue('');
          identificationNumberAvailableControl?.enable();
        }

      } else if (value === 'yes') {

        buyerTinControl?.enable();
        buyerTinControl?.setValue(
          buyerTinControl.value === buyerTinDefault ? '' : buyerTinControl.value
        );

        if (custType?.value === 'foreignNonIndividual') {
          identificationNumberAvailableControl?.setValue('yes');
          identificationNumberAvailableControl?.disable();
        }

        buyerTinControl?.markAsPristine();
        buyerTinControl?.markAsUntouched();
      }
      this.checkerror();
    }
    });

    identificationNumberAvailableControl?.valueChanges.subscribe((value) => {
      if (value === 'no') {
        identificationNumberControl?.setValue(identificationNumberDefault);
        identificationNumberControl?.disable();
      } else {
        identificationNumberControl?.enable();
        identificationNumberControl?.setValue(
          identificationNumberControl.value === identificationNumberDefault
            ? ''
            : identificationNumberControl.value
        );
        identificationNumberControl?.markAsPristine();
        identificationNumberControl?.markAsUntouched();
      }
      this.checkerror();
    });

    buyerTinControl?.updateValueAndValidity();
    identificationNumberControl?.updateValueAndValidity();
  }

  setForeignIndividualFields(customerType: string) {
    this.setCommonIndividualFields('EI00000000020', '000000000000', customerType);
  }

  setMalaysiaIndividualFields(customerType: string) {
    this.setCommonIndividualFields('EI00000000010', '000000000000', customerType);
  }

  setNonIndividualFields(customerType: string) {
    this.setCommonIndividualFields('EI00000000040', 'NA', customerType);
  }

  setForeignNonIndividualFields(customerType: string) {
    this.setCommonIndividualFields('EI00000000020', 'NA', customerType);
  }

  onValidate(): void {
    this.resetFlag = false;

    const formValues = this.buyerTinForm.value;
    console.log(this.buyerTinForm.value);

    if(formValues.customerType === 'foreignIndividual' &&
          formValues.buyerTinAvailable === 'no'){
            formValues.buyerTin = 'EI00000000020';
        }
        if(formValues.customerType === 'malaysiaIndividual' &&
          formValues.buyerTinAvailable === 'no'){
            formValues.buyerTin = 'EI00000000010';
        }
        if(formValues.customerType === 'nonIndividual' &&
          formValues.buyerTinAvailable === 'no'){
            formValues.buyerTin = 'EI00000000040';
        }
        if(formValues.customerType === 'foreignNonIndividual' &&
          formValues.buyerTinAvailable === 'no'){
            formValues.buyerTin = 'EI00000000020';
        }

    const isForeignIndividual =
      formValues.customerType === 'foreignIndividual' &&
      formValues.buyerTinAvailable === 'no' &&
      formValues.identificationNumberAvailable === 'yes' &&
      ['passport'].includes(formValues.identificationType);

    const isNonIndividualWithBRN =
      formValues.customerType === 'nonIndividual' &&
      formValues.buyerTinAvailable === 'no' &&
      formValues.identificationNumberAvailable === 'yes' &&
      formValues.identificationType === 'brn';

    const isNonIndividualWithoutIdentification =
      formValues.customerType === 'nonIndividual' &&
      formValues.buyerTinAvailable === 'no' &&
      formValues.identificationNumberAvailable === 'no' &&
      formValues.identificationType === 'brn';

    const isForeignNonIndividual =
      formValues.customerType === 'foreignNonIndividual' &&
      formValues.buyerTinAvailable === 'no' &&
      formValues.identificationType === 'brn';

    console.log(
      isForeignIndividual,
      isNonIndividualWithBRN,
      isNonIndividualWithoutIdentification,
      isForeignNonIndividual
    );
    if (
      this.buyerTinForm.valid &&
      !this.hasErrors &&
      (isForeignIndividual ||
        isNonIndividualWithBRN ||
        isNonIndividualWithoutIdentification ||
        isForeignNonIndividual)
    ) {
      this.formSubmit();
      console.log('Form submission logic executed without API call.');
    } else if (this.buyerTinForm.valid && !this.hasErrors) {
      let reqData = {
        customerType: formValues.customerType,
        buyerTinAvailable: formValues.buyerTinAvailable,
        buyerTin: formValues.buyerTin,
        identificationNumberAvailable: formValues.identificationNumberAvailable,
        identificationType: formValues.identificationType,
        identificationNumber: formValues.identificationNumber,
        sellerBRN:this.sellerBRN,
      };
      console.log("sellerBRN in BuyerTin: ",this.sellerBRN);
      this.buyerTinService.validateBuyerTin(reqData).subscribe(
        (response: any) => {
          const responseStatus = response.status || '';
          console.log('responseStatus', responseStatus);

          if (response.status == "Valid") {
            this.formSubmit();
            this.cdRef.detectChanges();
          }
          if (response.status == 'Invalid') {
            this.openErrorDialogue(response.message);
            this.resetFlag = true;
            this.cdRef.detectChanges();
          }
          else {
            console.log('Error');
          }
        },
        (error) => {
          console.log('Error', error);
        }
      );

      console.log('Form submitted with API call:', this.buyerTinForm.value);
    } else {
      console.log('Please fill all required fields or no API call needed.');
    }
  }

  openErrorDialogue(message: string) {
    this.dialogRef = this.dialogService.open(DialogComponent, {
      header: 'Error',
      width: '600px',
      data: {
        title: '',
        messages: [
          message
        ],

      },
      contentStyle: { 'max-height': '700px', overflow: 'auto' },
    });

  }

  openBuyerTinErrorDialogue(message: string) {
    this.dialogRef = this.dialogService.open(DialogComponent, {
      header: 'Confirmation',
      width: '600px',
      data: {
        title: '',
        messages: [
          'Is the Buyer falling under any of the special categories as below?',
          '<ul>' +
          '<li>Government</li>' +
          '<li>State government and state authority</li>' +
          '<li>Government authority</li>' +
          '<li>Local authority</li>' +
          '<li>Statutory authority and statutory body</li>' +
          '<li>Exempt institutions that are not assigned with TIN</li>' +
          '</ul>',
          message
        ],

      },
      contentStyle: { 'max-height': '700px', overflow: 'auto' },
    });

  }

  formSubmit() {
    this.isFormSubmitted = true;
    this.disableFormFields();
    this.formSubmitted.emit();
    // this.cdRef.detectChanges();
  }
  disableFormFields() {
    Object.keys(this.buyerTinForm.controls).forEach((key) => {
      this.buyerTinForm.get(key)?.disable();
    });
  }
  resetForm() {
    this.buyerTinForm.reset(); // Assuming your form is named 'buyerTinForm'
    this.isFormSubmitted = false;
    // Loop through all form controls and reset them
    Object.keys(this.buyerTinForm.controls).forEach((key) => {
      const control = this.buyerTinForm.get(key);
      if (control) {
        control.enable(); // Enable the control
        control.markAsPristine(); // Reset the pristine state
        control.markAsUntouched(); // Reset the touched state
      }
    });
  }
}